/* eslint-disable no-unused-vars */
/* eslint-disable react/button-has-type */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { GiCruiser } from 'react-icons/gi';
import AppSelect from '../../../shared/components/app-select/AppSelect';
import AppDatePicker from '../../../shared/components/app-date-picker/AppDatePicker';
import {
  formatDate,
  formatTimeString,
  getNewDate,
} from '../../../shared/helper-utils/appUtils';
import {
  API_DATE_FORMAT,
  NAVIGATION_ROUTES,
  TODAY_DATE,
} from '../../../shared/constants/Constants';

import CruiseCard from './CruiseCard';
import { getContentWithRoute } from '../../../api/loginApi';

const CRUISE = 'CRUISE';

const PREF_DESTINATION_OPTIONS = [
  { label: 'Any Destination', value: 'All' },
  { label: 'Antartica', value: 'AI' },
  { label: 'Artic', value: 'QP' },
  { label: 'Antartic circle', value: '6E' },
  { label: 'Antartic Peninsula', value: 'I5' },
  { label: 'Iceland', value: 'IC' },
  { label: 'South Shetland Islands', value: 'SSI' },
  { label: 'South Orkney Islands', value: 'SOI' },
  { label: 'Jan Mayen', value: 'JM' },
  { label: 'Weddell Sea', value: 'WS' },
  { label: 'St. Helena', value: 'SH' },
];

const PREF_ACTIVITY_OPTIONS = [
  { label: 'Any Activity', value: 'All' },
  { label: 'Sky Mountaineering', value: 'AI' },
  { label: 'Mountaineering', value: 'QP' },
  { label: 'Antartic Camping', value: '6E' },
  { label: 'Photo Workshop', value: 'I5' },
  { label: 'Base Camp', value: 'All' },
  { label: 'Birding', value: 'AI' },
  { label: 'Polar diving', value: 'QP' },
  { label: 'Hike and Sail', value: '6E' },
  { label: 'Long Hikes', value: 'I5' },
];

function CruiseComponent({ selectedTab, onTabSelect }) {
  const [trips, setTrips] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [prefDest, setPrefDest] = useState('All');
  const [prefAct, setPrefAct] = useState('All');
  const [fromDate, setFromDate] = useState(formatDate(getNewDate(TODAY_DATE)));
  const [showAll, setShowAll] = useState(false);

  const fetchTrips = async () => {
    setLoading(true);
    try {
      const response = await getContentWithRoute(
        'trip-feed/agents?currency=USD',
      );
      const data = await response;
      setTrips(data.trips);
      setError('');
    } catch (err) {
      setError('Failed to load trips');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTrips();
  }, []);

  const handleCruiseClick = () => {
    if (selectedTab !== CRUISE) {
      onTabSelect(CRUISE);
    }
  };

  return (
    <>
      <h2
        style={{ color: 'orange', display: 'flex', justifyContent: 'center' }}
      >
        SAVE BIG ON ARTIC TRIPS
      </h2>
      <div>
        <div style={{ padding: '20px', backgroundColor: '#f9f9f9' }}>
          {/* Filters */}
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              gap: '10px',
              marginBottom: '20px',
            }}
          >
            <AppSelect
              name="prefDest"
              placeholder=""
              label="Destination"
              options={PREF_DESTINATION_OPTIONS}
              onSelect={(d) => setPrefDest(d.value)}
              selectedValue={prefDest}
            />
            <AppSelect
              name="prefAct"
              placeholder=""
              label="Activity"
              options={PREF_ACTIVITY_OPTIONS}
              onSelect={(d) => setPrefAct(d.value)}
              selectedValue={prefAct}
            />
            <select>
              <option>Any date</option>
              <option>May 2025</option>
              <option>June 2025</option>
              <option>July 2025</option>
              <option>Aug 2025</option>
              <option>Sept 2025</option>
              <option>Oct 2025</option>
              <option>Nov 2025</option>
              <option>Dec 2025</option>
              <option>Jan 2026</option>
              <option>Feb 2026</option>
            </select>
            <button
              onClick={fetchTrips}
              style={{
                backgroundColor: '#ffb700',
                padding: '8px 16px',
                border: 'none',
                cursor: 'pointer',
                borderRadius: '10px',
              }}
            >
              Show cruises
            </button>
          </div>
          <p
            style={{ color: 'orange', fontSize: '24px', paddingLeft: '300px' }}
          >
            Antarctica cruises & Arctic cruises
          </p>
          {loading && <p>Loading cruises...</p>}
          {error && <p style={{ color: 'red' }}>{error}</p>}
          {!loading && !error && trips.length === 0 && <p>No cruises found.</p>}

          <div
            style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(3, 1fr)',
              gap: '20px',
            }}
          >
            {Array.isArray(trips) &&
              (!showAll ? trips.slice(0, 8) : trips).map((trip) => (
                <CruiseCard key={trip.id} trip={trip} />
              ))}
            {!showAll && trips.length > 8 && (
              <div
                style={{
                  padding: '20px',
                  border: '2px dashed #ccc',
                  borderRadius: '12px',
                  backgroundColor: '#fff3e0',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'center',
                  textAlign: 'center',
                  backgroundImage:
                    'url("https://storage.googleapis.com/oceanwide_web/media-dynamic/cache/widen_1200_avif/v2-gallery_media/media6241684f02517467823034.avif")',
                  backgroundSize: 'cover',
                  backgroundPosition: 'center',
                  backgroundRepeat: 'no-repeat',
                  // Optional: add a slight overlay to improve text readability
                  position: 'relative',
                  color: '#000', // Adjust text color if needed
                }}
              >
                {/* Optional overlay div */}
                <div
                  style={{
                    position: 'absolute',
                    top: 0,
                    right: 0,
                    bottom: 0,
                    left: 0,
                    backgroundColor: 'rgba(255, 243, 224, 0.6)', // Light translucent overlay
                    borderRadius: '12px',
                    pointerEvents: 'none',
                    zIndex: 0,
                  }}
                />

                {/* Content should be positioned above overlay */}
                <p
                  style={{
                    fontSize: '18px',
                    marginBottom: '10px',
                    position: 'relative',
                    zIndex: 1,
                  }}
                >
                  We have a total of <strong>{trips.length}</strong> cruises
                  available.
                </p>
                <button
                  onClick={() => setShowAll(true)}
                  style={{
                    backgroundColor: '#007b8f',
                    color: 'white',
                    padding: '10px 20px',
                    border: 'none',
                    borderRadius: '8px',
                    cursor: 'pointer',
                    position: 'relative',
                    zIndex: 1,
                  }}
                >
                  Show All Cruises
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

CruiseComponent.propTypes = {
  selectedTab: PropTypes.string.isRequired,
  onTabSelect: PropTypes.func.isRequired,
};

export default CruiseComponent;
